import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 6,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    background: theme.palette.grey[200],
    padding: theme.spacing(2),
    margin: '8px 0'
  },
  roomCard: {
    display: 'grid',
    gridTemplateColumns: '2fr 1.5fr 1fr',
    alignItems: 'center',
    background: theme.palette.background.default,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(1.5),
      gap: theme.spacing(1.5)
    }
  },
  header: {
    fontWeight: 500,
    marginBottom: 10,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
      marginBottom: theme.spacing(1)
    }
  },
  text: {
    fontWeight: 500,
    fontSize: 14,
    color: theme.palette.grey[700],
    [theme.breakpoints.down('sm')]: {
      fontSize: 13
    }
  },
  roomInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '100%'
  },
  title: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '1.6rem',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15
    }
  },
  divider: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(0.5)
    }
  },
  detailItem: {
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center'
    }
  },
  icon: {
    marginRight: 6,
    fontSize: 20,
    marginBottom: 1,
    color: theme.palette.grey[700]
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      gap: theme.spacing(0.5)
    }
  },
  blackText: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12 // ↓ smaller so check-in & check-out fit in one line
    }
  },
  subtitle: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    paddingLeft: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      paddingLeft: 0
    }
  },
  midCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))
